/**
 * Copyright © 2026 Adnuntius AS.
 */
import {firstValueFrom} from 'rxjs';
import {Component, Inject, OnInit, signal} from '@angular/core';
import {resourceOptionParams} from '../common/controller/signal-admin-resource-api';
import * as _ from 'lodash';
import {AppEventBusService} from '../common/events/app-event-bus.service';

import {Api404ContextService} from './api-404-context.service';
import template from './api404-page.component.html';
import {NetworkApiService} from '../admin/network/network-api.service';
import {AdnNetworkHelperService} from '../../components/util/adn-network-helper.service';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';
import {LocalUserProfile} from '../../components/session/local-user-profile';
import {BrowserLocationService} from '../angular-platform-providers';
import {StateService} from '@uirouter/core';
import {AppSharedModule} from '../common/app-shared.module';

@Component({
  standalone: true,
  selector: 'adn-api404-page',
  imports: [AppSharedModule],
  template
})
export class Api404PageComponent implements OnInit {
  errorType = 'default';
  url = '';
  objectId: string;
  username: string;
  hasOtherNetworks = false;
  allChecked = signal(false);
  networks = signal<any[] | null>(null);

  constructor(
    private readonly eventBus: AppEventBusService,
    private readonly $state: StateService,
    @Inject(BrowserLocationService) private readonly location: any,
    private readonly Api404Context: Api404ContextService,
    @Inject(LocalNetworkProfile) private readonly LocalNetworkProfile: any,
    @Inject(LocalUserProfile) private readonly localUserProfile: any,
    @Inject(AdnNetworkHelperService) private readonly adnNetworkHelper: any,
    @Inject(NetworkApiService) private readonly Network: NetworkApiService
  ) {
  }

  ngOnInit(): void {
    const rejection = this.Api404Context.consumeRejection(null);
    this.url = _.get(rejection, ['config', 'url'], this.location.pathname);

    if (!rejection || !rejection.data) {
      return;
    }

    if (rejection.data.code === 'error.object.not.found') {
      this.errorType = 'objectNotFound';
      this.objectId = this.getObjectId(this.url);
      this.username = this.location.queryParams.username;

      const networkTagIds = _.filter(this.localUserProfile.get('networkTagIds'), (networkTagId: string) => {
        return networkTagId !== _.get(rejection, ['config', 'params', 'context']);
      });
      this.hasOtherNetworks = networkTagIds.length > 0;
      this.allChecked.set(networkTagIds.length < 2 || false);

      const currentNetworkId = this.LocalNetworkProfile.getNetworkId();
      firstValueFrom(this.Network.listOptions(resourceOptionParams(_.isString(this.username) ? {username: this.username} : {object: this.objectId}))).then((data: any) => {
          this.networks.set(_.filter(data.results, (n: any) => n.id !== currentNetworkId));
          this.allChecked.set(true);
        }, () => {
          this.networks.set(null);
          this.allChecked.set(true);
        });
    } else {
      this.errorType = 'default';
    }
  }

  switchNetwork(network: any): void {
    const ctrl: any = {};
    this.adnNetworkHelper.switchNetwork(ctrl, this.eventBus, network);
    if (this.username) {
      this.$state.go('app.adm.users');
    }
  }

  private getObjectId(url: string): string {
    const splitArray = url.split('/');
    return splitArray[splitArray.length - 1];
  }
}
